{
  "UnifiedNavigation": "Navegue en Experience Cloud",
  "adobeExperienceCloudNoOrgsSelect": "Seleccione otra cuenta de organización",
  "help": "Ayuda",
  "profile": "Perfil",
  "searchButton": "Buscar",
  "sidenavMenuCloseTooltip": "Cerrar el menú",
  "sidenavMenuOpenTooltip": "Abrir el menú",
  "solutionSwitcher": "Cambiar a otra solución",
  "toggleSideNav": "Alternar menú de navegación lateral"
}
